/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_TranslateInputs */

const cs_property_ai_translate = /** @type {(inputs: Property_Ai_TranslateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeložit AI`)
};

const en_property_ai_translate = /** @type {(inputs: Property_Ai_TranslateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate with AI`)
};

/**
* | output |
* | --- |
* | "Translate with AI" |
*
* @param {Property_Ai_TranslateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_translate = /** @type {((inputs?: Property_Ai_TranslateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_TranslateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_translate(inputs)
	return cs_property_ai_translate(inputs)
});